export default __webpack_public_path__ + "static/media/userIcon.b78aecf8.webp";